import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { HorizontalIndicator } from "@itandi/itandi-bb-ui/HorizontalIndicator";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { TopArea } from "./TopArea";

type Props = {
	deleting: boolean;
	handleDrop: (files: File[]) => Promise<void>;
	processedCount: number;
	totalCount: number;
	uploading: boolean;
};

export function ReportImageUploadPanel({
	uploading,
	deleting,
	processedCount,
	totalCount,
	handleDrop
}: Props) {
	return (
		<>
			{uploading || deleting ? (
				<Alertv2 variant={uploading ? "info" : "warning"}>
					<Paragraph>
						現在画像を{uploading ? "アップロード" : "削除"}中です。
						<br />
						画面を移動すると、{uploading ? "アップロード" : "削除"}
						が正常に完了しない場合があります。
					</Paragraph>
					<Grid
						alignItems="center"
						gap={designTokens["spacing/xxs"]}
						mt={designTokens["spacing/xxs"]}
						templateColumns="auto max-content"
					>
						<HorizontalIndicator
							ratio={totalCount === 0 ? 0 : processedCount / totalCount}
							variant={uploading ? "info" : "warning"}
							width="100%"
						/>
						<Label size="s">{`${processedCount}/${totalCount}件完了`}</Label>
					</Grid>
				</Alertv2>
			) : null}
			{!deleting && !uploading && <TopArea handleDrop={handleDrop} />}
		</>
	);
}
